import { render, staticRenderFns } from "./pay-channel-item.vue?vue&type=template&id=d01d602c&scoped=true&"
import script from "./pay-channel-item.vue?vue&type=script&lang=js&"
export * from "./pay-channel-item.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel-item.vue?vue&type=style&index=0&id=d01d602c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01d602c",
  null
  
)

export default component.exports